import endpoints from "hooks/api/endpoints";
import useApiGet, { UseApiGetOptions } from "hooks/api/useApiGet";
import useProjectId from "hooks/ProjectScope";
import IndividualItemResponse from "types/IndividualItemResponse";
import VideoSignedUrlDto from "types/VideoSignedUrlDto";

export default function useGetSignedVideoUrls(
  videoId?: string,
  options?: {
    suspendRequest?: boolean;
  } & UseApiGetOptions,
) {
  const projectId = useProjectId();
  const { result, ...rest } = useApiGet<
    IndividualItemResponse<VideoSignedUrlDto>
  >(
    options?.suspendRequest
      ? ""
      : endpoints.getSignedUrlsForVideo(projectId, videoId),
    options,
  );

  return {
    transcodeUrl: result?.data.video,
    ...result?.data,
    ...rest,
  };
}
